import { Company } from '@/utils/Interfaces'
import { RootState } from './index'
import { Module } from 'vuex'
import Vue from 'vue'
import { endpoints } from '@/utils/ApiEndpoints'

const companyEndpoint = endpoints.core.company.crud

declare interface CompanyState {
  companies: Array<Company>;
  fetchingCompanies: boolean;
}

export const company: Module<CompanyState, RootState> = {
  state: {
    companies: [],
    fetchingCompanies: false,
  },

  getters: {
    hasCompanies (state) {
      return state.companies.length > 0
    },
    getCompanies (state) {
      return state.companies
    },
    getCompanyBySlug: (state) => (slug: string) => {
      return state.companies.find(company => company.slug === slug)
    },
    getParentCompanies (state) {
      return state.companies.filter(company => company.company_type === 'PARENT')
    },
    getSubsidiaryCompanies (state) {
      return state.companies.filter(company => company.company_type === 'SUBSIDIARY')
    },
    getAssociatedCompanies (state) {
      return state.companies.filter(company => company.company_type === 'ASSOCIATED')
    },
    getLimitedCompanies (state) {
      return state.companies.filter(company => company.company_type === 'LIMITED')
    },
  },

  mutations: {
    SET_COMPANIES (state, companies) {
      state.companies = companies
    },

    SET_FETCHING_COMPANIES (state, isFetching: boolean) {
      state.fetchingCompanies = isFetching
    },

    CHANGE_COMPANY (state, { slug, updatedCompany }) {
      for (let index = 0; index < state.companies.length; index ++) {
        const targetCompany = state.companies[index]
        if (targetCompany.slug === slug) {
          state.companies[index] = updatedCompany
          break
        }
      }
    },
  },

  actions: {
    setCompanies (context) {
      return new Promise((resolve, reject) => {
        // If store already having companies, no need to commit anything
        let companies = context.getters.getCompanies
        if (companies.length > 0) {
          resolve(companies)
          return
        }

        // If store has no companies, call api and commit SET_COMPANIES with its response
        context.commit('SET_FETCHING_COMPANIES', true)
        Vue.axios.get(companyEndpoint)
          .then(response => {
            companies = response.data
            context.commit('SET_COMPANIES', companies)
            resolve(companies)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            context.commit('SET_FETCHING_COMPANIES', false)
          })
      })
    },

    updateCompany (context, { slug, company }) {
      return Vue.axios.patch(companyEndpoint + slug + '/', company)
                      .then(response => {
                        const updatedCompany = response.data
                        context.commit('CHANGE_COMPANY', { slug, updatedCompany })
                      })
    },

    clearCompanies (context) {
      context.commit('SET_COMPANIES', [])
    },
  }
}
